import { render, staticRenderFns } from "./AssignBalanceConfirmationDialog.vue?vue&type=template&id=64b5f298&scoped=true&lang=pug&"
import script from "./AssignBalanceConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./AssignBalanceConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignBalanceConfirmationDialog.vue?vue&type=style&index=0&id=64b5f298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5f298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
